import type { Middleware } from 'redux'
import bulletin from '@/sections/teacher/bulletin/middlewares'
const middlewares: Middleware[] = [...bulletin]

export default middlewares
